// src/Pages/Admin/Zones/ZoneList.tsx
import React from "react";
import { Zone } from "./types";

interface ZoneListProps {
    zones: Zone[];
    onEdit: (zoneID: number) => void;
    onDelete: (zoneID: number) => void;
}

const ZoneList: React.FC<ZoneListProps> = ({ zones, onEdit, onDelete }) => {
    return (
        <div className="event-table-container">
            <table className="event-table event-table-modern">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Nummer</th>
                        <th>Navn</th>
                        <th>Handlinger</th>
                    </tr>
                </thead>
                <tbody>
                    {zones.map((z) => (
                        <tr key={z.zoneID}>
                            <td>{z.zoneID ?? "-"}</td>
                            <td>{z.number}</td>
                            <td>{z.zoneName}</td>
                            <td>
                                <div className="table-buttons">
                                    <button className="edit-btn" onClick={() => onEdit(z.zoneID!)}>
                                        Rediger
                                    </button>
                                    <button className="delete-btn" onClick={() => onDelete(z.zoneID!)}>
                                        Slet
                                    </button>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default ZoneList;